import axios from "axios";
import Notie from "@/services/NotieService";

/**
 * @description
 * Service for anything scoring workflow related.
 */
export default {
	/**
	 * @description
	 * Returns a promise of sections this user is assigned to.
	 */
	mySections() {
		return axios.get("/v3/sections");
	},

	/**
	 * @description
	 * Returns a promise of statistics for a user by section
	 */
	sectionStats() {
		return axios.get("/v3/stat/sections");
	},

	getItem(id) {
		return axios.get(`/v3/item/${id}`);
	},

	getBackreadingStats(section_id, item_id, team_ids) {
		return axios.post(`/v3/stat/backreading`, {
			section_id: section_id,
			item_id: item_id,
			team_ids: team_ids
		});
	},

	unlockResponse(resp) {
		return axios.post(`/v3/unlock/${resp.id}`);
	},

	canScore(resp) {
		if (resp.locked) {
			return false;
		}
		//Unscored, rel, res, review
		if (
			resp.state == 1 ||
			resp.state == 2 ||
			resp.state == 3 ||
			resp.state == 30
		) {
			return true;
		}

		return false;
	},

	auditScore(resp, router, keep) {
		var url = "";
		console.log("resp", resp);
		switch (resp.state) {
			case 1:
				url = `/scoring/${resp.assessment_id}/${resp.item_id}/${resp.class_id}/${resp.delivery_id}`;
				break;
			case 2:
				url = `/second_score/${resp.assessment_id}/${resp.item_id}`;
				break;
			case 3:
				url = `/resolution/${resp.assessment_id}/${resp.item_id}`;
				break;
			default:
				url = "???";
		}
		if (url == "???") {
			Notie.error(`Response is in an error state - ID ${resp.id}`);
		} else {
			this.auditQueueUp(resp.id)
				.then(data => {
					var query = {
						return: true,
						skipqc: true
					};
					if (keep) {
						query.keep = true;
					}
					//setTimeout(function () {
					router.push({ path: url, query: query });
					//}, 200)
				})
				.catch(data => {
					console.log(data);
					//Notie.error("Failed to audit response", 2000, "red");
				});
		}
	},

	auditQueueUp(id) {
		return axios.get(`/v3/auditqueue/${id}`);
	},

	resetScore(responseID, scoreID) {
		return axios.delete(`/v3/reset/${responseID}/${scoreID}`);
	},

	escalate(escalateRequest) {
		return axios.post("/v3/escalate/qc", escalateRequest);
	},

	escalateExemplar(escalateRequest) {
		return axios.post("/v3/escalate/exemplar", escalateRequest);
	},

	flagResponse(flagRequest) {
		return axios.post("/v3/flag", flagRequest);
	},

	deleteFlag(responseID, flagID) {
		return axios.delete(`/v3/flag/${responseID}/${flagID}`);
	},

	updateFlag(responseID, flag) {
		return axios.post(`/v3/flag/update/${responseID}/${flag.id}`, flag);
	},

	getStateAfterRelease(responseID) {
		return axios.get(`/v3/flag/release_state/${responseID}`);
	},

	releaseFromFlagged(responseID) {
		return axios.post(`/v3/flag/release/${responseID}`);
	},

	markReviewed(responseID, flagID) {
		return axios.post(`/v3/flag/review/${responseID}/${flagID}`);
	},

	markNotReviewed(responseID, flagID) {
		return axios.post(`/v3/flag/unreview/${responseID}/${flagID}`);
	},

	addScoringNote(responseID, note) {
		let req = { note: note };
		return axios.post(`/v3/response/${responseID}/scoring_note`, req);
	},

	removeScoringNote(responseID) {
		return axios.delete(`/v3/response/${responseID}/scoring_note`);
	}
};



// WEBPACK FOOTER //
// ./src/services/ScoringService.js